import Vue from 'vue'

const state = {
    provinces: [],
    cities: [],
    districts: [],
    loading: false,
    error: null,
}

const mutations = {
    // Mutation Provinces
    SET_PROVINCES(state, data) {
        state.provinces = data
    },
    CLEAR_PROVINCES(state) {
        state.provinces = []
    },

    // Mutation Cities
    SET_CITIES(state, data) {
        state.cities = data
    },
    CLEAR_CITIES(state) {
        state.cities = []
    },

    // Mutation District
    SET_DISTRICTS(state, data) {
        state.districts = data
    },
    CLEAR_DISTRICTS(state) {
        state.districts = []
    },

    //Mutation States
    SET_LOADING(state, value) {
        state.loading = value
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    CLEAR_ERROR(state) {
        state.error = null
    },
}

const actions = {
    async fetchProvinces({ commit }) {
        commit('SET_LOADING', true)
        commit('CLEAR_ERROR')
        commit('CLEAR_PROVINCES')
        commit('CLEAR_CITIES')
        commit('CLEAR_DISTRICTS')
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.get(process.env.API_GET_PROVINCE, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            commit('SET_PROVINCES', response.data.content || [])
            return response.data.content || []
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch provinces')
            console.error('Error fetching provinces:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchCities({ commit }, provinceId) {
        commit('SET_LOADING', true)
        commit('CLEAR_ERROR')
        commit('CLEAR_CITIES')
        commit('CLEAR_DISTRICTS')
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.post(
                process.env.API_GET_KABKOT,
                {
                    provinceId: provinceId,
                },
                {
                    headers: { "Asani-Token": localStorage.getItem("jwt") },
                }
            )
            commit('SET_CITIES', response.data.content || [])
            return response.data.content || []
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch cities')
            console.error('Error fetching cities:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchDistricts({ commit }, cityId) {
        commit('SET_LOADING', true)
        commit('CLEAR_ERROR')
        commit('CLEAR_DISTRICTS')
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.post(process.env.API_GET_KECAMATAN, {
                kabKotId: cityId,
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            })
            commit('SET_DISTRICTS', response.data.content || [])
            return response.data.content || []
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch districts')
            console.error('Error fetching districts:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    },

    clearCities({ commit }) {
        commit('SET_CITIES', [])
    },

    clearDistricts({ commit }) {
        commit('SET_DISTRICTS', [])
    },

    clearProvinces({ commit }) {
        commit('SET_PROVINCES', [])
    },
}

const getters = {
    getProvinces: (state) => state.provinces,
    getCities: (state) => state.cities,
    getDistricts: (state) => state.districts,
    getLoading: (state) => state.loading,
    getError: (state) => state.error,
    getProvincesSelectOptions: (state) => {
        return state.provinces.map(province => ({
            label: province.provinceName,
            value: province.provinceId,
        }))
    },
    getCitySelectOptions: (state) => {
        return state.cities.map(city => ({
            label: city.kabKotName,
            value: city.kabKotId,
        }))
    },
    getDistrictSelectOptions: (state) => {
        return state.districts.map(district => ({
            label: district.kecamatanName,
            value: district.kecamatanId,
        }))
    },
    getProvincesSelectByNameOptions: (state) => {
        return state.provinces.map(province => ({
            label: province.provinceName,
            value: province.provinceName,
        }))
    },
    getCitySelectByNameOptions: (state) => {
        return state.cities.map(city => ({
            label: city.kabKotName,
            value: city.kabKotName,
        }))
    },
    getDistrictSelectByNameOptions: (state) => {
        return state.districts.map(district => ({
            label: district.kecamatanName,
            value: district.kecamatanName,
        }))
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/others.js